import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

import { useMytaverseEvent } from '../../../../../../modules/dashboard/providers';
import { useMytaverse } from '../../../../../../providers/MytaverseProvider';
import { defaultIdleTimeout } from '../../../../../../constants/idleTimeout';
import { env } from '../../../../../../env';

const TAGS = ['presignedhub', 'fulltimehub'];

const useIdleTimerLogout = () => {
  const { currentEvent } = useMytaverseEvent();
  const { logoutUser } = useMytaverse();

  const [isIdleDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (currentEvent?.eventTags) {
      const tags = currentEvent?.eventTags.filter((tag) =>
        TAGS.includes(tag.toLowerCase()),
      );
      setIsDisabled(tags?.length <= 0);
    }
  }, [currentEvent?.eventTags]);

  useIdleTimer({
    timeout:
      Number(env.REACT_APP_IDLE_TIMEOUT_MINS || defaultIdleTimeout) * 60000, // in minutes
    onIdle: () => logoutUser(),
    onActive: () => console.log('Idle Timer Active'),
    element: document,
    disabled: isIdleDisabled,
  });
};

export default useIdleTimerLogout;
